<script lang="ts">
	import { Notice } from "@ishavskraft/shared";
	import AreaSelect from "./[...path=spotprisenPath]/AreaSelect.svelte";
	import DetectAreaButton from "#lib/DetectAreaButton.svelte";
	import type { Omraade } from "#lib/types/omraade.js";
	import type { DayView } from "#lib/utils/spotprisenViews.js";

	type Props = {
		currentArea: Omraade;
		/** Spotprisen call site: lets AreaSelect build its default
		 *  `/spotprisen/<view>/<slug>` hrefs. Ignored when hrefBuilder is set. */
		view?: DayView;
		/** Historikk call site: full control over each area pill's href. */
		hrefBuilder?: (slug: string) => string;
		/** DetectAreaButton target — receives the resolved Omraade after a
		 *  successful geolocation match. */
		detectHref: (area: Omraade) => string;
		class?: string;
	};

	let { currentArea, view, hrefBuilder, detectHref, class: classes = "" }: Props = $props();

	let detectError = $state<string | null>(null);
</script>

<div class={["area-controls contain-content", classes]}>
	<AreaSelect {currentArea} {view} {hrefBuilder} class="my-0" />
	<div class="detect-slot relative">
		<p class="detect my-0">
			<DetectAreaButton
				buildHref={detectHref}
				bind:error={detectError}
				class="px-0 py-1 underline decoration-primary-strong min-w-0 text-sm leading-tight min-h-[48px]"
			/>
		</p>
	</div>
	{#if detectError}
		<Notice inline tone="error" body={detectError} class="error text-xs" />
	{/if}
</div>

<style lang="postcss">
	.area-controls {
		display: grid;
		grid-template-columns: 1fr auto;
		align-items: start;
		gap: var(--s-2);
	}

	.area-controls:has(:global(details[open])) {
		grid-template-columns: 1fr 0;
		gap: 0;
	}

	.area-controls:has(:global(details[open])) .detect-slot {
		& .detect {
			position: absolute;
			right: 0;
			top: 0;
			/* No z-index: AreaSelect's summary has z-index: 1 so it covers
			 * the button where they overlap (back-behind summary); document
			 * order keeps the button painting after the non-positioned <ul>
			 * panel, so the button stays in FRONT of the pills. */
			white-space: nowrap;
		}
	}

	.error {
		grid-column: 1 / -1;
		margin-block-start: var(--s-2);
	}
</style>
